// VesselSchedulesListing.js

import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import exportFromJSON from "export-from-json";
import PdfGenerater from "./PdfGeneratorVesselListing";
import { getTimeStampForReports } from "../../utils/DataFormate";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFileCsv,
  faFileExcel,
  faFileCode,
} from "@fortawesome/free-solid-svg-icons";
import { languageJson } from "../../StringVariable";
import axios from "src/redux/actions/apis";
import "./report.css";
import { VESSEL_OPERATIONS_URL } from "../../url/Url";

function VesselSchedulesListing() {
  const [reportData, setReportData] = useState(null);
  const [exportList, setExportList] = useState([]);

  const { export_PDF_txt, export_Excel_txt, export_CSV_txt, export_XML_txt } =
    languageJson;

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const res = await axios.get(VESSEL_OPERATIONS_URL);
      setReportData(res.data?.vessels || []);
    } catch (error) {
      console.error("Error fetching vessel schedules:", error);
      setReportData([]);
    }
  };

  const formatDateTime = (timestamp) => {
    if (!timestamp || timestamp === "") return "-";
    const num = Number(timestamp);
    const dateObj = !isNaN(num) ? moment(num) : moment(timestamp);
    return dateObj.isValid()
      ? dateObj.tz("America/Los_Angeles").format("MM/DD/YYYY h:mm A")
      : "-";
  };

  const formatRow = (item, category) => {
    switch (category.toLowerCase()) {
      case "vessels in port":
      case "expected arrivals":
      case "long term schedule":
        return {
          "Vessel Name": item.vesselName || "-",
          "Terminal Name": item.terminal || "-",
          "Estimated Arrival": formatDateTime(item.estimatedArrival),
        };

      case "due to depart":
        return {
          "Vessel Name": item.vesselName || "-",
          "Terminal Name": item.terminal || "-",
          "Loading Cutoff": formatDateTime(item.cutoffDate),
          "Estimated Arrival": formatDateTime(item.estimatedArrival),
        };

      default:
        return {
          "Vessel Name": item.vesselName || "-",
          "Terminal Name": item.terminal || "-",
          "Estimated Arrival": formatDateTime(item.estimatedArrival),
        };
    }
  };

  const fileName = `Vessel Schedules Detailed Report-${getTimeStampForReports().replace(
    /:/g,
    "-"
  )}`;

  const downloadXml = () => {
    exportFromJSON({
      data: exportList,
      fileName,
      exportType: "xml",
    });
  };

  const downloadExcel = () => {
    exportFromJSON({
      data: exportList,
      fileName,
      exportType: "xls",
    });
  };

  // Build export list whenever reportData updates
  useEffect(() => {
    if (reportData && reportData.length > 0) {
      const formatted = [];
      reportData.forEach((section) => {
        const vessels = section.vesselsList || [];
        // Process categories that contain items
        if (vessels.length > 0) {
          formatted.push({
            "Vessel Name": `*** ${section.category.toUpperCase()} ***`,
          });

          vessels.forEach((item) => {
            formatted.push(formatRow(item, section.category));
          });

          formatted.push({});
        }
      });
      setExportList(formatted);
    }
  }, [reportData]);

  return (
    <div className="container">
      {/* Top action row right aligned */}
      <div
        className="d-flex justify-content-end align-items-center"
        style={{
          width: "100%",
          marginTop: "-20px",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          {/* PDF button */}
          <span title={export_PDF_txt}>
            <PdfGenerater
              reportData={reportData}
              buttonclassName={"pdfbutton"}
              buttonTitle={<FontAwesomeIcon icon={faFilePdf} size="lg" />}
              title={languageJson.vesselOperation_txt}
              fileName={fileName}
              formatRow={formatRow}
              getSectionData={(section) => section.vesselsList || []}
              size={"A1"}
            />
          </span>

          {/* CSV button */}
          <span title={export_CSV_txt}>
            <CSVLink
              data={exportList}
              filename={`${fileName}.csv`}
              className="downloadBtny btn btn-primary downloadbutton"
            >
              <FontAwesomeIcon icon={faFileCsv} size="lg" />
            </CSVLink>
          </span>

          {/* Excel button */}
          <span title={export_Excel_txt}>
            <button
              className="downloadBtny btn btn-primary downloadbutton"
              onClick={downloadExcel}
            >
              <FontAwesomeIcon icon={faFileExcel} size="lg" />
            </button>
          </span>

          {/* XML button */}
          <div title={export_XML_txt}>
            <button
              className="downloadBtny btn btn-primary downloadbutton"
              onClick={downloadXml}
            >
              <FontAwesomeIcon icon={faFileCode} size="lg" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VesselSchedulesListing;
